module.exports = __webpack_public_path__ + "img/about1.96f59eed.jpg";